import { render, staticRenderFns } from "./agreement5.vue?vue&type=template&id=82484142&scoped=true"
var script = {}
import style0 from "./agreement5.vue?vue&type=style&index=0&id=82484142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82484142",
  null
  
)

export default component.exports